import RelativesActionsLightbox from './RelativesActionsLightbox';

export default RelativesActionsLightbox;



// WEBPACK FOOTER //
// ./src/js/components/Lightbox/index.js